// extracted by mini-css-extract-plugin
export default {"groups":"styles_groups__-ACIJ"};